import React, { Component } from "react";
import { ChevronLeft, ChevronRight } from 'lucide-react';
import i18n from '../i18n';

const CATEGORY_ICONS = {
  'Tutti':        '✨',
  'Musica':       '🎵',
  'Sport':        '⚽',
  'Cinema':       '🎬',
  'Concerto':     '🎤',
  'Teatro':       '🎭',
  'Arte & Teatro':'🎨',
  'Famiglia':     '👨‍👩‍👧',
  'Altro':        '🌟',
  'Generale':     '📌',
};

const CATEGORY_LABELS_EN = {
  'Tutti':        'All',
  'Musica':       'Music',
  'Sport':        'Sport',
  'Cinema':       'Cinema',
  'Concerto':     'Concert',
  'Teatro':       'Theatre',
  'Arte & Teatro':'Arts',
  'Famiglia':     'Family',
  'Altro':        'Other',
  'Generale':     'General',
};

const getCategoryLabel = (label) => {
  if (i18n.language === 'en') return CATEGORY_LABELS_EN[label] || label;
  return label;
};

class ButtonNav extends Component {
  constructor(props) {
    super(props);
    this.scrollRef = React.createRef();
  }

  scrollLeft  = () => this.scrollRef.current?.scrollBy({ left: -180, behavior: 'smooth' });
  scrollRight = () => this.scrollRef.current?.scrollBy({ left: 180, behavior: 'smooth' });

  handleClick = (label) => {
    if (this.props.onButtonClick) this.props.onButtonClick(label);
  };

  render() {
    const { items = [] } = this.props;
    const activeLabel = items.find(b => b.checked)?.label || '';

    return (
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center', padding: '0.5rem 0 1.25rem' }}>
        {/* Left arrow */}
        <button
          onClick={this.scrollLeft}
          className="d-none d-sm-flex"
          style={{
            flexShrink: 0,
            width: 36, height: 36,
            borderRadius: '50%',
            border: '1.5px solid var(--border)',
            background: 'var(--surface)',
            color: 'var(--text-muted)',
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 'var(--shadow-sm)',
            marginRight: 8,
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => { e.target.style.background = 'var(--primary)'; e.target.style.color = '#fff'; e.target.style.borderColor = 'var(--primary)'; }}
          onMouseLeave={e => { e.target.style.background = 'var(--surface)'; e.target.style.color = 'var(--text-muted)'; e.target.style.borderColor = 'var(--border)'; }}
        >
          <ChevronLeft size={16} />
        </button>

        {/* Scroll container */}
        <div
          ref={this.scrollRef}
          style={{
            display: 'flex',
            gap: '0.5rem',
            overflowX: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            flex: 1,
            padding: '0.25rem 0.1rem',
          }}
        >
          {items.map((btn) => {
            const isActive = btn.label === activeLabel;
            const icon = CATEGORY_ICONS[btn.label] || '📌';
            return (
              <button
                key={btn.id}
                onClick={() => this.handleClick(btn.label)}
                style={{
                  flexShrink: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.4rem',
                  padding: '0.48rem 1.1rem',
                  borderRadius: '9999px',
                  border: isActive ? 'none' : '1.5px solid var(--border)',
                  background: isActive
                    ? 'linear-gradient(135deg, var(--primary), var(--secondary))'
                    : 'var(--surface)',
                  color: isActive ? '#fff' : 'var(--text-muted)',
                  fontFamily: 'Poppins, sans-serif',
                  fontWeight: 600,
                  fontSize: '0.84rem',
                  cursor: 'pointer',
                  boxShadow: isActive
                    ? '0 4px 14px rgba(var(--primary-rgb),0.35)'
                    : 'var(--shadow-sm)',
                  transition: 'all 0.2s',
                  whiteSpace: 'nowrap',
                }}
                onMouseEnter={e => {
                  if (!isActive) {
                    e.currentTarget.style.borderColor = 'var(--primary-light)';
                    e.currentTarget.style.color = 'var(--primary)';
                    e.currentTarget.style.background = 'var(--gradient-soft)';
                  }
                }}
                onMouseLeave={e => {
                  if (!isActive) {
                    e.currentTarget.style.borderColor = 'var(--border)';
                    e.currentTarget.style.color = 'var(--text-muted)';
                    e.currentTarget.style.background = 'var(--surface)';
                  }
                }}
              >
                <span>{icon}</span>
                {getCategoryLabel(btn.label)}
              </button>
            );
          })}
        </div>

        {/* Right arrow */}
        <button
          onClick={this.scrollRight}
          className="d-none d-sm-flex"
          style={{
            flexShrink: 0,
            width: 36, height: 36,
            borderRadius: '50%',
            border: '1.5px solid var(--border)',
            background: 'var(--surface)',
            color: 'var(--text-muted)',
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: 'var(--shadow-sm)',
            marginLeft: 8,
            transition: 'all 0.2s',
          }}
          onMouseEnter={e => { e.currentTarget.style.background = 'var(--primary)'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = 'var(--primary)'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'var(--surface)'; e.currentTarget.style.color = 'var(--text-muted)'; e.currentTarget.style.borderColor = 'var(--border)'; }}
        >
          <ChevronRight size={16} />
        </button>

        <style>{`.overflow-auto::-webkit-scrollbar{display:none}`}</style>
      </div>
    );
  }
}

export default ButtonNav;
